var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeaderContainer"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"circle"},[_vm._v("\n      "+_vm._s(_vm.chapter)+"\n    ")]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }